import { render, staticRenderFns } from "./ScrollableBenefits.vue?vue&type=template&id=7e20ae94&scoped=true"
import script from "./ScrollableBenefits.vue?vue&type=script&lang=js"
export * from "./ScrollableBenefits.vue?vue&type=script&lang=js"
import style0 from "./ScrollableBenefits.vue?vue&type=style&index=0&id=7e20ae94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20ae94",
  null
  
)

export default component.exports